
export const navbar = {
  'backoffice.navbar.notifications': 'Notifications',
  'backoffice.navbar.language': 'Language',
  'backoffice.navbar.signIn': 'Sign in'
};
